import { Component } from '@angular/core';

@Component({
  selector: 'app-eye',
  styleUrls: ['./center.style.css'],
  template: `
    <div class="center">

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.9302 13.0899C16.1513 6.91455 7.84899 6.91455 5.07011 13.0899C4.92846 13.4046 4.55845 13.545 4.24368 13.4033C3.9289 13.2617 3.78855 12.8917 3.9302 12.5769C7.15132 5.41887 16.849 5.41887 20.0701 12.5769C20.2118 12.8917 20.0714 13.2617 19.7566 13.4033C19.4419 13.545 19.0719 13.4046 18.9302 13.0899Z" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12.0002 11.7917C10.9646 11.7917 10.1252 12.6311 10.1252 13.6667C10.1252 14.7023 10.9646 15.5417 12.0002 15.5417C13.0357 15.5417 13.8752 14.7023 13.8752 13.6667C13.8752 12.6311 13.0357 11.7917 12.0002 11.7917ZM8.87515 13.6667C8.87515 11.9408 10.2742 10.5417 12.0002 10.5417C13.7261 10.5417 15.1252 11.9408 15.1252 13.6667C15.1252 15.3926 13.7261 16.7917 12.0002 16.7917C10.2742 16.7917 8.87515 15.3926 8.87515 13.6667Z" fill="white" />
    </svg>
  
    </div>`
})
export class EyeComponent {}
